import React from 'react';

const HeaderPorteFeuil = () => {
  return (
    <div className="bg-white rounded-xl shadow p-2 mb-2 flex justify-between items-center">
      <h1 className="text-xl font-bold text-gray-800">📊 Analyse portefeuille clients</h1>
      
    </div>
  );
};

export default HeaderPorteFeuil;